export default function PricingSection() {
  return (
    <section className="bg-white py-16">
      <div className="max-w-10xl mx-auto px-6">
        <div className="mb-16 text-center">
          <h2 className="text-3xl font-bold text-gray-600">
            Choose Your Pricing Options
          </h2>
        </div>

        <div className="flex flex-col items-center justify-center gap-8 lg:flex-row lg:items-start">
          {/* Early Bird Seat - Sold Out */}
          <div className="relative max-w-xl rounded-lg border border-gray-300 bg-white">
            <div className="rounded-t-lg bg-gray-200 p-8">
              <div className="text-4xl font-bold text-gray-600">
                Early Bird Seat
              </div>
            </div>
            <div className="relative p-8">
              <div className="absolute -top-5 right-0">
                <img
                  src="/img/gijinkoku/map-japan-pricing1.svg"
                  alt="Japan map"
                  className="h-auto w-auto"
                />
              </div>
              <div className="mb-8">
                <div className="mb-2 text-5xl font-bold text-gray-600">
                  N3 Ready
                  <br />
                  Bootcamp <span className="text-xl">+</span>{' '}
                  <span className="relative -top-2 rounded-full border border-gray-600 px-6 py-3 text-sm text-gray-600">
                    Work Preparation
                  </span>
                </div>
              </div>

              <div className="mb-4 flex items-center gap-3">
                <div className="text-2xl text-gray-600 line-through">
                  IDR 25.000.000
                </div>
                <div className="flex items-center gap-1 rounded-full bg-gray-200 px-3 py-1">
                  <img src="/img/gijinkoku/Vector_5.svg" alt="Vector" />
                  <div className="font-bold text-gray-600">Save 58%</div>
                </div>
              </div>
              <div className="mb-6 text-5xl font-bold text-gray-600">
                IDR 10.449.000
              </div>

              <div className="mb-8 rounded-lg bg-gray-200 p-5">
                <ul className="list-inside list-disc space-y-2 text-gray-600">
                  <li>
                    <span className="font-bold">FULL PAYMENT</span> dapatkan
                    cashback senilai IDR 500.000
                  </li>
                  <li>
                    Tersedia opsi pembayaran dengan{' '}
                    <span className="font-bold">skema cicilan 3x</span>. Hubungi
                    tim admission untuk info selengkapnya.
                  </li>
                </ul>
              </div>

              <div className="mb-8 space-y-4 px-6">
                {[
                  'Live Sessions bersama Sensei berpengalaman (Senin - Kamis)',
                  'Speaking Practice dengan Speaking Assistant',
                  'Self-Learning di YES LMS: latihan Kanji, vocab, reading, listening',
                  'Weekly Knowledge Check setiap Jumat',
                  '2x Career Mentoring Live Sessions (CV Writing)',
                  '2x 1-on-1 Coaching Sessions (Mock Interview)',
                  'Fleksibel, sesuai dengan jadwal kamu dan Career Coach',
                ].map((feature, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <img
                      src="/img/gijinkoku/checklist.png"
                      alt="Check"
                      className="mt-0.5 h-6 w-6"
                    />
                    <div className="text-sm leading-tight text-gray-600">
                      <span className="font-bold">
                        {feature.split(' ')[0]} {feature.split(' ')[1]}
                      </span>
                      <br />
                      {feature.split(' ').slice(2).join(' ')}
                    </div>
                  </div>
                ))}
              </div>

              <button className="w-full cursor-not-allowed rounded-3xl bg-gray-400 py-4 font-bold text-gray-600">
                Slot Penuh (Early Bird Seat)
              </button>
            </div>
          </div>

          {/* 2nd Wave Seat - Available */}
          <div className="w-full max-w-xl rounded-lg bg-[#d91f2e]">
            <div className="rounded-t-lg bg-red-800 p-8">
              <div className="text-4xl font-bold text-white">2nd Wave Seat</div>
            </div>
            <div className="p-8">
              <div className="mb-8">
                <div className="mb-2 text-5xl font-bold text-white">
                  N3 Ready
                  <br />
                  Bootcamp <span className="text-xl">+</span>{' '}
                  <span className="relative -top-2 rounded-full border border-white px-4 py-1 text-sm">
                    Work Preparation
                  </span>
                </div>
              </div>

              <div className="mb-4 flex items-center gap-3">
                <div className="text-2xl text-white line-through">
                  IDR 25.000.000
                </div>
                <div className="flex items-center gap-1 rounded-full bg-gray-200 bg-white px-3">
                  <img
                    src="/img/gijinkoku/lsiconbadge-promotion-filled_1.svg"
                    alt="Vector"
                  />
                  <div className="text-sm font-bold text-red-800">Save 54%</div>
                </div>
              </div>
              <div className="mb-6 text-5xl font-bold text-white">
                IDR 11.449.000
              </div>

              <div className="mb-8 rounded-lg bg-yes-800 p-5">
                <ul className="list-inside list-disc space-y-2 text-white">
                  <li>
                    <span className="font-bold">FULL PAYMENT</span> dapatkan
                    cashback senilai IDR 500.000
                  </li>
                  <li>
                    Tersedia opsi pembayaran dengan{' '}
                    <span className="font-bold">skema cicilan 3x</span>. Hubungi
                    tim admission untuk info selengkapnya.
                  </li>
                </ul>
              </div>

              <a
                href="https://forms.gle/LFP8wrfLrDA2Woh86"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full rounded-3xl bg-green-600 py-4 text-center font-bold text-white transition-colors hover:bg-green-600"
              >
                Daftar Sekarang
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
